// src/api/schedules/index.js
import api from "../axios";

export const scheduleApi = {
  listMy() {
    return api.get("/schedules/schedules/");
  },
  listPersonal() {
    return api.get("/schedules/schedules/?scope=personal");
  },
  listProject(projectId) {
    return api.get(`/schedules/schedules/?scope=project&project=${projectId}`);
  },
  listCompany(companyId) {
    return api.get(`/schedules/schedules/?scope=company&company=${companyId}`);
  },
  detail(id) {
    return api.get(`/schedules/schedules/${id}/`);
  },
  create(data) {
    return api.post("/schedules/schedules/", data);
  },
  update(id, data) {
    return api.put(`/schedules/schedules/${id}/`, data);
  },
  remove(id) {
    return api.delete(`/schedules/schedules/${id}/`);
  },
};
